import { auth, db } from "../firebase/firebase.config.js";

// Stores
import { UserStore, BankStore, ExpenseStore } from "../store";

const getData = auth.onAuthStateChanged((user) => {
	if (user) {
		const authStatus = true;
		const fullName = user.displayName;
		const uid = user.uid;
		const uidCollection = db.collection(uid);
		let uidCollectionData = {};

		UserStore.update((currentUser) => {
			return {
				fullName: fullName,
				uid: uid,
				authStatus: authStatus,
			};
		});

		if (uidCollection) {
			uidCollection.get().then((querySnapShot) => {
				if (!querySnapShot.empty) {
					querySnapShot.forEach((doc) => {
						uidCollectionData[`${doc.id}`] = doc.data();

						BankStore.set(uidCollectionData.banks);

						ExpenseStore.update((data) => {
							data.data = uidCollectionData.expenses;
							return data;
						});
					});
				} else {
					console.log("data doesnt exists");
				}
			});
		}

		// let bankData = querySnapShot.data();
		// BankStore.set(bankData);
	} else {
		console.log("no user to get data");
		UserStore.update((currentUser) => {
			return {
				authStatus: false,
			};
		});
	}
});

export default getData;
